<!-- This is placeholder content for the Game Streaming service (e.g. Reemo.io) -->
<script>
  import { fade } from 'svelte/transition';
  import {
    connected,
    gameReady,
    isLoading,
    multiPlayer,
    multiPlayerStatus,
    player,
    status,
  } from './stores';
</script>

{#if $isLoading || ($connected && !$gameReady)}
  <div class="loading-screen" transition:fade>
    <div class="animated-bg" />
    <div class="player-id-wrapper">
      <div class="player1 player-id">
        {#if $player === 1 && $multiPlayer}
          P1
        {/if}
      </div>
      <div class="player2 player-id">
        {#if $player === 2 && $multiPlayer}
          P2
        {/if}
      </div>
    </div>
    <div class="content">
      {#if $status === 'connecting'}
        <div class="loader" />
      {/if}

      <p>{$status}</p>
      <p>{$multiPlayerStatus}</p>
      <!-- Write out your current connecting state here... -->
    </div>
  </div>
{/if}

<style>
  .animated-bg {
    filter: blur(1.5px);
    /* filter: brightness(0); */
    opacity: 0.15;
    mix-blend-mode: overlay;

    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url('/icons/bg-icons-2.png') repeat 0 0;

    -webkit-animation: bg-scrolling-reverse 10s infinite; /* Safari 4+ */
    -moz-animation: bg-scrolling-reverse 10s infinite; /* Fx 5+ */
    -o-animation: bg-scrolling-reverse 10s infinite; /* Opera 12+ */
    animation: bg-scrolling-reverse 10s infinite; /* IE 10+ */
    -webkit-animation-timing-function: linear;
    -moz-animation-timing-function: linear;
    -o-animation-timing-function: linear;
    animation-timing-function: linear;
  }

  /* Loader Animation */
  .content {
    color: black;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .loader {
    display: inline-block;
    margin: 20px 0 0;
    border: 6px solid rgba(0, 0, 0, 0.15); /* Orange */
    border-top: 6px solid #000; /* White */
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 0.4s linear infinite;
  }
  .loading-screen {
    z-index: 1999;

    display: flex;
    justify-content: center;
    align-items: center;

    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    vertical-align: middle;
    text-align: center;

    background: rgb(255, 193, 7, 1);
    /* background: radial-gradient(
      circle,
      rgba(255, 193, 7, 1) 65%,
      rgba(222, 166, 0, 1) 100%
    ); */
    /* background: linear-gradient(135deg, rgba(251,170,0,1) 0%, rgba(241,90,36,1) 100%) */
  }

  .player-id-wrapper {
    align-items: center;
    color: #a70be0;
    display: flex;
    flex-direction: row;
    font: 800 3rem 'Roboto', sans-serif;
    height: 100px;
    justify-content: space-between;
    left: 0;
    position: fixed;
    top: 30%;
    width: 100%;
    z-index: 1000;
    -webkit-text-stroke: #fff 2px;
  }

  .player-id-wrapper .player1 {
    margin-left: 2rem;
  }

  .player-id-wrapper .player2 {
    margin-right: 2rem;
  }

  /* Animations */
  @-webkit-keyframes bg-scrolling-reverse {
    100% {
      background-position: 250px -250px;
    }
  }
  @-moz-keyframes bg-scrolling-reverse {
    100% {
      background-position: 250px -250px;
    }
  }
  @-o-keyframes bg-scrolling-reverse {
    100% {
      background-position: 250px -250px;
    }
  }
  @keyframes bg-scrolling-reverse {
    100% {
      background-position: 250px -250px;
    }
  }

  @-webkit-keyframes bg-scrolling {
    0% {
      background-position: 250px -250px;
    }
  }
  @-moz-keyframes bg-scrolling {
    0% {
      background-position: 250px -250px;
    }
  }
  @-o-keyframes bg-scrolling {
    0% {
      background-position: 250px -250px;
    }
  }
  @keyframes bg-scrolling {
    0% {
      background-position: 250px -250px;
    }
  }

  /* Background */

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
